// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlight-red {\n  background-color: #dd4a68;\n  color: #000;\n}\n.highlight-red:hover td {\n  background-color: #e03e2d !important;\n  color: #000 !important;\n  cursor: pointer;\n}\n.m-modal .ant-modal-header {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
